import { Box } from "@repo/ui/core";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";
import Footer from "./Footer";
import Navigation from "./Navigation";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function LandingLayout() {
  return (
    <Box style={{ background: "var(--na-bg)", minHeight: "100dvh" }}>
      <ScrollToTop />
      <Navigation />
      <main>
        <Outlet />
      </main>
      <Footer />
    </Box>
  );
}
